import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';

import * as staticsApi from '../../lib/api/statics';


import { finishLoading, startLoading } from '../loading';

const [VIEW_USER_CONFIG, VIEW_USER_CONFIG_SUCCESS, VIEW_USER_CONFIG_FAILURE] =
    createRequestActionTypes('statics/VIEW_USER_CONFIG');
export const viewUserConfig = createAction(VIEW_USER_CONFIG, (searchData) => searchData);
const viewUserConfigSaga = createRequestSaga(VIEW_USER_CONFIG, staticsApi.getStatConfByUser);


const UNLOAD_USER_CONFIG = 'statics/UNLOAD_USER_CONFIG';
export const unloadUserConfig = createAction(UNLOAD_USER_CONFIG);

const SET_USER_CONFIG = 'statics/SET_USER_CONFIG';
export const setUserConfig = createAction(SET_USER_CONFIG, (userConfig) => userConfig);




export function* userConfigSaga() {
    yield takeLatest(VIEW_USER_CONFIG, viewUserConfigSaga);
}



const initialState = {
    userConfig: null,
    error: null,
};

const userConfig = handleActions(
    {
        [VIEW_USER_CONFIG_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            userConfig: data.list.map((config) => ({
                month: config.month,
                ptargetSales: Number(config.ptargetSales),
                ptargetSalesProfit: Number(config.ptargetSalesProfit),
                ptargetOperatingProfit: Number(config.ptargetOperatingProfit || 0),
            })),
        }),
        [VIEW_USER_CONFIG_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [UNLOAD_USER_CONFIG]: () => initialState,
        [SET_USER_CONFIG]: (state, { payload: data }) => ({
            ...state,
            userConfig: data.list.map((config) => ({
                month: config.month,
                ptargetSales: Number(config.ptargetSales),
                ptargetSalesProfit: Number(config.ptargetSalesProfit),
                ptargetOperatingProfit: Number(config.ptargetOperatingProfit || 0),
            })),
        }),
    },
    initialState,
);


export default userConfig;
